export default "__VITE_ASSET__BSsSgOIY__"